export var FilterSplitStrategy = /*#__PURE__*/ function(FilterSplitStrategy) {
    FilterSplitStrategy["FILTER_SPLIT_STRATEGY_UNKNOWN"] = "FILTER_SPLIT_STRATEGY_UNKNOWN";
    /**
   * ES should only return products, not aggregations
   */ FilterSplitStrategy["PRODUCTS_ONLY"] = "PRODUCTS_ONLY";
    /**
   * ES should only return aggregations, no products
   */ FilterSplitStrategy["AGGREGATIONS_ONLY"] = "AGGREGATIONS_ONLY";
    /**
   * ES should return both aggregations and products
   */ FilterSplitStrategy["PRODUCTS_AND_AGGREGATIONS"] = "PRODUCTS_AND_AGGREGATIONS";
    return FilterSplitStrategy;
}({});
